import { Col, DatePicker, Form, message, Row, Slider } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import StSerialBlock from '../pages/InputCreater/StSerialBlock';

const Slicer = ({
    colSpan,
    name,
    queryLayout,
    label,
    serialBlock,
    labelCol,
    defaultValue,
    form,
    disabled,
    placeholder,
    width,
    required,
    errorMessage,
    validateFunction,
    minDate,
    maxDate,
    bg,
    isIST,
    format
}) => {
    const [serialBlockData, setSerialBlockData] = useState();

    useEffect(() => {
        if (defaultValue && form) {
            form.setFieldsValue({
                [name]: [
                    dayjs(defaultValue[0]),
                    dayjs(defaultValue[1]),
                ]
            });
            onRangeChange([
                dayjs(defaultValue[0]),
                dayjs(defaultValue[1]),
            ])
        }
    }, []);

    const onRangeChange = (e) => {
        let startDate = dayjs(e[0]);
        let endDate = dayjs(e[1]);
        let difference = endDate.diff(startDate, 'days');
        // if(difference >=30 ){
        //     return message.error('Please select date between 30 days only');
        // }
        form.setFieldValue(serialBlock.data_index, null);
        let sbData = [];
        for (var i = 0; i < (difference + 1); i++) {
            let date = dayjs(startDate).add(i, 'days').format('YYYY-MM-DD');
            let day = dayjs(date).get('date');
            sbData.push({
                "blockStyle": { ...serialBlock.blockStyle },
                // "icon": {
                //     "img": "https://pixsector.com/cache/517d8be6/av5c8336583e291842624.png",
                //     "style": {
                //         "width": "50px",
                //         "display": "block",
                //         "margin": "auto",
                //         "height": "auto"
                //     }
                // },
                "title": {
                    "text": day,
                    "toolTip": date,
                    "style": { ...serialBlock.titleStyle }
                },
                "val": date
            })
        };
        setSerialBlockData(sbData);
    }

    const rangePicker = (
        <Col span={colSpan || 7}>
            <Form.Item
                name={name}
                label={label}
                labelCol={{ span: labelCol ? labelCol : 8 }}
                initialValue={!form && [
                    defaultValue ? dayjs(defaultValue[0]) : "",
                    defaultValue ? dayjs(defaultValue[1]) : "",
                ]}
                placeholder={placeholder}
                style={{ width: '100%', fontWeight: 600 }}
                rules={[
                    { required: required, message: errorMessage },
                    () => ({
                        validator(rule, value) {
                            return validateFunction
                                ? validateFunction(rule, value)
                                : Promise.resolve();
                        },
                    }),
                ]}
            >
                <DatePicker.RangePicker
                    onChange={onRangeChange}
                    minDate={minDate ? dayjs(minDate, "YYYY-MM-DD") : undefined}
                    maxDate={maxDate ? dayjs(maxDate, "YYYY-MM-DD") : undefined}
                    disabled={disabled}
                    showTime={false}
                    style={{ backgroundColor: bg, fontWeight: 600, minHeight: 40 }}
                    use12Hours={isIST ? isIST : false}
                    format={format ? format : "YYYY-MM-DD hh:mm:ss"}
                    className="gx-mb-3 gx-w-100"
                    placeholder={["Start Date", "End Date"]}
                />
            </Form.Item>
        </Col>
    );

    const serialBlocks = (
        <Col span={serialBlock?.colSize || 17} style={{ paddingLeft: queryLayout === 'singleLine' ? 10 : 0 }}>
            {
                serialBlockData ?
                    <StSerialBlock
                        options={serialBlockData}
                        submitOnClick={serialBlock.submitOnClick}
                        name={serialBlock.data_index}
                        form={form}
                        // data={data}
                        defaultValue={serialBlock.defaultValue}
                        label={serialBlock.label}
                        required={serialBlock.required}
                        disabled={false}
                        errorMessage={
                            serialBlock.errorMessage ||
                            'Please select'
                        }
                    /> : <></>
            }

        </Col>
    )

    return (
        <>
            {
                queryLayout === 'singleLine' ?
                    <Row style={{ width: '100%' }} justify={"center"}>
                        {rangePicker}
                        {serialBlocks}
                    </Row> :
                    <>
                        <Col span={24}>
                            <Row justify={"center"}>
                                {rangePicker}
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row justify={"center"}>
                                {serialBlocks}
                            </Row>
                        </Col>
                    </>
            }
        </>
    )
};

export default Slicer;